import { EditorState, RichUtils } from 'draft-js';

import { linkHandleKeyCommand } from '../Toolbar/Items/Link';
import { LinkPortalController } from '../Toolbar/Items/Link/useLinkPortal';
import * as t from '../Wysiwyg.types';

export const useHandleKeyCommand = (props: {
  editorState: EditorState;
  linkPortalController: LinkPortalController;
  setEditorState: (state: EditorState) => void;
  setIsEditorActive: (state: boolean) => void;
  handleChange: (newEditorState: EditorState, forceSelection?: boolean) => void;
  keyCommandHandler?: t.KeyCommandHandler;
}) => {
  const handleKeyCommand = (command: string, editorState: EditorState) => {
    // From props
    if (props.keyCommandHandler) {
      const result = props.keyCommandHandler(command, editorState);
      if (result === 'handled') {
        return 'handled';
      }
    }

    // Link
    const linkKeyCommand = linkHandleKeyCommand(
      command,
      props.editorState,
      props.setEditorState,
      props.setIsEditorActive,
      props.handleChange,
      props.linkPortalController,
    );
    if (linkKeyCommand === 'handled') return linkKeyCommand;

    // Default
    const newState = RichUtils.handleKeyCommand(editorState, command);
    if (newState) {
      props.handleChange(newState);
      return 'handled';
    }

    return 'not-handled';
  };

  return handleKeyCommand;
};
